<template>
  <div>
    <form
        @submit.prevent="submitForm"
        class="ecommerce-form action-buttons-fixed"
        novalidate
    >
      <div class="row" v-if="Object.keys(settings).length">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-toggle-right"></i>
                  <h2 class="card-big-info-title">Postavke artikla</h2>
                  <p class="card-big-info-desc">Definirajte osnovne parametre.</p>
                </div>
                <div class="col-lg-3-5 col-xl-4-5">
                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end">
                      Broj prikazanih artikala
                    </label>
                    <div class="col-lg-7 col-xl-8">
                      <div class="switch switch-success">
                        <input class="form-control form-control-modern" v-model="settings.numberOfDisplayedArticles"/>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end">
                      Osvježavanje proizvoda za vas
                    </label>
                    <div class="col-lg-7 col-xl-8">
                      <div class="switch switch-success">
                        <input
                          type="number"
                          min="1"
                          class="form-control form-control-modern"
                          v-model.number="settings.randomRefreshRateCustomerCustomizedArticles"
                        />
                      </div>
                      <small class="text-muted d-block mt-2">
                        Broj sati nakon kojih se lista „Proizvodi za vas“ osvježava (npr. 3 = svaka 3 sata).
                      </small>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="row action-buttons">
        <div class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3">
          <button
            type="submit"
            class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { translations } from '@/mixins';
import api from '@/services/api';

export default {
  name: 'UserArticlesSettings',
  mixins: [translations],
  data() {
    return {
      key: 'UserArticlesSettings',
    };
  },
  methods: {
    submitForm() {
      api.updateSettings(this.key, this.settings).then((response) => {
        this.$toast.info(response.data.info);
      }).catch((err) => {
        this.$toast.error(err.response.data.info);
      });
    },
  },
  computed: {
    settings() {
      return this.$store.getters.getSettings;
    },
  },
  mounted() {
    this.$store.dispatch('getSettings', this.key);
  },
  destroyed() {
    this.$store.commit('INIT_SETTINGS', {});
  },
};
</script>